import { useState } from 'react';
import { Box, Tab, Tabs, Typography } from '@mui/material';
import PurchaseBooksPage from './PurchaseBooksPage';

const BooksPurchasesPage = () => {
  const [tab, setTab] = useState('taxpayers');

  return (
    <Box>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h5" component="h1" gutterBottom>
          Libros - Compras
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Compras a contribuyentes y consumidor final.
        </Typography>
      </Box>

      <Tabs
        value={tab}
        onChange={(_, value) => setTab(value)}
        sx={{ mb: 2 }}
      >
        <Tab value="taxpayers" label="Compras a contribuyentes" />
        <Tab value="consumer" label="Compras consumidor final" />
      </Tabs>

      {tab === 'taxpayers' ? (
        <PurchaseBooksPage
          title="Compras a contribuyentes (Anexo 3)"
          subtitle="Ingreso manual, vista previa y generación del formato MH."
          bookType="compras_contribuyentes"
        />
      ) : (
        <PurchaseBooksPage
          title="Compras consumidor final"
          subtitle="Ingreso manual, vista previa y generación del formato MH."
          bookType="compras_consumidor_final"
        />
      )}
    </Box>
  );
};

export default BooksPurchasesPage;

